import ReactSelect, { components } from 'react-select';
import { FormErrorMessage, FormControl, Box, Text } from '@chakra-ui/react';
import { Field, ErrorMessage } from 'formik';
import { NoOptionsMessage } from '@/components/select';
import React from 'react';
import { useState } from 'react';
import { customFilterStyles } from './customFilterStyles';

export const CustomValueContainer = ({
  getValue,
  expanded,
  children,
  selectedFilter,
  toggleExpandCollapse,
  ...props
}) => {
  const maxToShow = 2;
  const [showAll, setShowAll] = useState(expanded);
  const length = getValue().length;
  const displayChips = React.Children.toArray(children).filter(
    (child) => child?.type?.name !== 'Input'
  );
  const inputComponent = React.Children.toArray(children).find(
    (child) => child?.type?.name === 'Input'
  );
  const displayLength = length - maxToShow;

  const handleToggleShowAll = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setShowAll((prev) => !prev);
    toggleExpandCollapse();
  };
  const shouldBadgeShow = length > maxToShow;

  return (
    <components.ValueContainer {...props}>
      {selectedFilter && selectedFilter.length > 0 ? (
        showAll ? (
          <>
            {displayChips}
            {inputComponent}
          </>
        ) : (
          <>
            {displayChips.slice(0, maxToShow)}
            {inputComponent}
          </>
        )
      ) : (
        <>
          {displayChips}
          {inputComponent}
        </>
      )}

      {!showAll && shouldBadgeShow && (
        <Box
          flex="1"
          onClick={handleToggleShowAll}
          onMouseDown={(e) => e.stopPropagation()}
          cursor="pointer"
        >
          <Box
            borderRadius="6px"
            p="4px 8px"
            border="1px solid #EFECF0"
            width="fit-content"
            m="2px"
          >
            <Text fontWeight="semiBold" fontSize="12px" color="ats-primary">
              {'+' + displayLength}
            </Text>
          </Box>
        </Box>
      )}
    </components.ValueContainer>
  );
};

export const SelectV1 = ({
  components = {},
  expanded = undefined,
  previousSelectedFilter = {},
  menuIsOpen = undefined,
  toggleExpandCollapse = () => {},
  ...props
}) => {
  const defaultComponents = {
    IndicatorSeparator: null,
    NoOptionsMessage,
    ValueContainer: (customProps) => (
      <CustomValueContainer
        {...customProps}
        expanded={expanded}
        selectedFilter={props.selectedFilter}
        toggleExpandCollapse={toggleExpandCollapse}
      />
    ),
  };

  return (
    <ReactSelect
      styles={customFilterStyles([])}
      components={{ ...defaultComponents, ...components }}
      getOptionLabel={(option) => option.label}
      getOptionValue={(option) => option.value}
      menuIsOpen={menuIsOpen}
      menuPortalTarget={document.body}
      {...props}
    />
  );
};

export const FormSelect = ({
  id,
  onChange = () => {},
  onOpen = () => {},
  ...selectProps
}) => {
  if (!id) {
    console.error('id is required for form field');
    return;
  }

  return (
    <Field name={id} id={id}>
      {({ field: { value }, form }) => (
        <FormControl
          isRequired
          isInvalid={form.errors?.[id] && form.touched?.[id]}
        >
          <SelectV1
            {...selectProps}
            value={value}
            hasError={form.errors?.[id] && form.touched?.[id]}
            onMenuOpen={onOpen}
            onChange={(selected) => {
              form?.setFieldValue(id, selected);
              onChange(selected);
            }}
          />
          <FormErrorMessage>
            <ErrorMessage name={id} />
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
